export { PaymentsPopUpService } from './payments-popup.service';
export { PaymentsPopUpServiceMock } from './payments-popup.mock';
